/** Shared SalonTym checkout / payment styling — use on desktop `Payment` and mobile `PaymentMobile`. */

export const PAYMENT_MINT = "#1f7a4d";
export const PAYMENT_MINT_DARK = "#123524";

export const paymentGradient =
  "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)";
export const paymentGradientHover =
  "linear-gradient(135deg, #0f2a1c 0%, #1a6b42 100%)";

export const paymentBorderSubtle = "1px solid rgba(31, 122, 77, 0.18)";
export const paymentBorderPill = "1px solid rgba(31, 122, 77, 0.22)";

/** Primary CTA — Proceed to payment / Book now */
export const paymentPrimaryButtonSx = {
  fontSize: "0.95rem",
  fontWeight: 800,
  padding: "12px 24px",
  borderRadius: "999px",
  minHeight: 48,
  textTransform: "none" as const,
  background: paymentGradient,
  boxShadow: "0 10px 26px rgba(31, 122, 77, 0.28)",
  color: "#fff",
  "&:hover": {
    background: paymentGradientHover,
    boxShadow: "0 12px 28px rgba(31, 122, 77, 0.32)",
  },
};

/** Radio / payment method row */
export const paymentMethodRowSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: paymentBorderPill,
  padding: "10px 1rem 10px 0px",
  borderRadius: "52px",
  margin: "0px 0px 1rem",
  bgcolor: "rgba(255,255,255,0.98)",
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    borderColor: "rgba(31, 122, 77, 0.35)",
    boxShadow: "0 4px 14px rgba(18, 53, 36, 0.08)",
  },
};

/** Mobile cart / checkout cards (address, wallet, etc.) */
export const cartMobileSurfaceSx = {
  background: "#fff",
  padding: "12px 14px",
  borderRadius: "16px",
  border: "1px solid rgba(31, 122, 77, 0.12)",
  boxShadow: "0 4px 18px rgba(15, 23, 17, 0.06)",
};

/** Desktop payment dialog paper */
export const paymentDialogPaperSx = {
  borderRadius: { xs: 0, sm: "20px" },
  overflow: "hidden",
  border: { xs: "none", sm: `1px solid rgba(31, 122, 77, 0.12)` },
  boxShadow: {
    xs: "none",
    sm: "0 24px 48px rgba(15, 23, 17, 0.12)",
  },
  maxHeight: { xs: "100%", sm: "min(92vh, 880px)" },
  display: "flex",
  flexDirection: "column",
  m: { xs: 0, sm: 2 },
};
